<template>
    <div class="row" :style="rowStyle">
        <div class="col-12">
            <div class="row">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Select the data fields for your custom audience.</span>
                    </v-tooltip>

                    <i class="fas fa-hdd"></i> <span style="padding-left: 5px;"> Data</span>
                </div>

                <div class="form-group col-md-2" v-if="[analyses.types.apps].includes(analysisType)">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="signal_providers"
                                :items="$store.getters['CreateAudienceStore/getSignalProvidersAll'](dataSetOrder)"
                                label="Signal Provider"
                                multiple
                                :rules="[requiredSignalsProviders]"
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('signal_providers_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('signal_providers_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ signal_providers.length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_signal_providers" placeholder="Search" @input="searchItems(dataSetOrder, 'signal_providers')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'signal_providers')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getSignalProvidersSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'signal_providers') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

                <div class="form-group col-md-2" v-if="[analyses.types.apps].includes(analysisType)">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="apps_categories"
                                :items="$store.getters['CreateAudienceStore/getAppsCategoriesAll'](dataSetOrder)"
                                label="Categories"
                                @change="appsCategoriesChanged"
                                multiple
                                :rules="[requiredCategoriesOrTags]"
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('apps_categories_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('apps_categories_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getAppsCategoriesSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_apps_categories" placeholder="Search" @input="searchItems(dataSetOrder, 'apps_categories')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'apps_categories')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getAppsCategoriesSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'apps_categories') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

                <div class="form-group col-md-2" v-if="[analyses.types.apps].includes(analysisType)">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="apps_tags"
                                :items="$store.getters['CreateAudienceStore/getAppsTagsAll'](dataSetOrder)"
                                label="Tags"
                                @change="$store.dispatch('CreateAudienceStore/fetchAppsBundleids', dataSetOrder)"
                                multiple
                                :rules="[requiredCategoriesOrTags]"
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('apps_tags_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('apps_tags_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getAppsTagsSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_apps_tags" placeholder="Search" @input="searchItems(dataSetOrder, 'apps_tags')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

                <div class="form-group col-md-2" v-if="[analyses.types.apps].includes(analysisType)">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="apps_bundleids"
                                :items="$store.getters['CreateAudienceStore/getAppsBundleidsAll'](dataSetOrder)"
                                label="Apps Names"
                                multiple
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('apps_bundleids_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('apps_bundleids_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getAppsBundleidsSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_apps_bundleids" placeholder="Search" @input="searchItems(dataSetOrder, 'apps_bundleids')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

            </div>

            <div class="row" v-if="[analyses.types.apps].includes(analysisType) && $store.getters.isPowerUser">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Insert custom bundle id?</span>
                    </v-tooltip>

                    <i class="fas fa-mobile"></i> <span style="padding-left: 5px;">Bundle IDs</span>
                </div>

                <div class="form-group col-md-2 push-down-36">
                    <v-switch
                        v-model="insert_custom_bundleids"
                        inset
                    ></v-switch>
                </div><!--form-group-->
            </div>

            <div class="row" v-if="[analyses.types.apps].includes(analysisType) && $store.getters.isPowerUser && insert_custom_bundleids">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Insert Custom Bundle IDs, <br> one Bundle ID in one row.</span>
                    </v-tooltip>

                    <i class="fas fa-location-arrow"></i> <span style="padding-left: 5px;"> Bundle IDs</span>
                </div>
                <div class="form-group col-md-4">
                    <v-textarea
                        v-model="bundleids_ids"
                        label="Bundle IDs"
                        rows="3"
                        hint="One Bundle ID in one row"
                        :rules="[bundleIdsValidation]"
                    ></v-textarea>
                </div><!--form-group-->
            </div>

            <div class="row" v-if="[analyses.types.apps].includes(analysisType)">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Select your targeted audience's location fields by country</span>
                    </v-tooltip>

                    <i class="fas fa-blender-phone"></i> <span style="padding-left: 5px;"> Device Attributes </span>
                </div>
                <div class="form-group col-md-2" v-if="[analyses.types.apps].includes(analysisType)">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="apps_os"
                                :items="$store.getters['CreateAudienceStore/getAppsOsAll'](dataSetOrder)"
                                label="Device OS"
                                multiple
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('apps_os_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('apps_os_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getAppsOsSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_apps_os" placeholder="Search" @input="searchItems(dataSetOrder, 'apps_os')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'apps_os')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getAppsOsSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'apps_os') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

            </div>

            <div class="row" v-if="[analyses.types.apps].includes(analysisType)">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Select your targeted audience's location fields by country</span>
                    </v-tooltip>

                    <i class="fas fa-location-arrow"></i> <span style="padding-left: 5px;"> Location </span>
                </div>
                <div class="form-group col-md-2">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="countries"
                                :items="$store.getters['CreateAudienceStore/getCountriesAll'](dataSetOrder)"
                                label="Country"
                                multiple
                                :rules="[requiredCountries]"
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('countries_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('countries_' + dataSetOrder)"
                            >
                                <template v-slot:item="{ active, item, attrs, on }">
                                    <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                        <v-list-item-action>
                                            <v-checkbox :input-value="active"></v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ item.text }} <small>({{ item.value }})</small>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>

                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getCountriesSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_countries" placeholder="Search" @input="searchItems(dataSetOrder, 'countries')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'countries')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getCountriesSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'countries') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

            </div>

        </div>
    </div>
</template>

<script>
import analyses from "../../../../../mixin/analyses"
import {mapState} from "vuex";
export default {
    name: "AppsData",
    mixins: [analyses],
    props: [
        'dataSetOrder',
        'rowStyle',
        'analysisType'
    ],
    data: () => ({
        requiredSignalsProviders: v => v && v.length > 0 || 'Signal Provider field is required',
        requiredCountries: v => v && v.length > 0 || 'Country field is required',
    }),
    methods: {
        requiredCategoriesOrTags(v) {
            if ([this.analyses.types.apps].includes(this.analysisType)) {
                if (this.$store.getters['CreateAudienceStore/getAppsCategoriesSelected'](this.dataSetOrder).length > 0 || this.$store.getters['CreateAudienceStore/getAppsTagsSelected'](this.dataSetOrder).length > 0) {
                    return true
                }
            }

            return 'Categories or Tags field is required'
        },
        appsCategoriesChanged() {
            this.$store.dispatch('CreateAudienceStore/fetchAppsTagsByCategories', this.dataSetOrder)
            this.$store.dispatch('CreateAudienceStore/fetchAppsBundleids', this.dataSetOrder)
        }
    },
    computed: {
        signal_providers: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSignalProvidersSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_SIGNAL_PROVIDERS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_signal_providers: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSignalProvidersSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_SIGNAL_PROVIDERS_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        apps_categories: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAppsCategoriesSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_APPS_CATEGORIES', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_apps_categories: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAppsCategoriesSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_APPS_CATEGORIES_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        apps_tags: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAppsTagsSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_APPS_TAGS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_apps_tags: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAppsTagsSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_APPS_TAGS_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        apps_bundleids: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAppsBundleidsSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_APPS_BUNDLEIDS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_apps_bundleids: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAppsBundleidsSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_APPS_BUNDLEIDS_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        apps_os: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAppsOsSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_APPS_OS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_apps_os: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAppsOsSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_APPS_OS_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        countries: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCountriesSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_COUNTRIES', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_countries: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCountriesSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_COUNTRIES_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        insert_custom_bundleids: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAppsBundleidsInsertCustomStatus'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_APPS_BUNDLEIDS_INSERT_CUSTOM', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        bundleids_ids: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAppsBundleidsCustomIds'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_APPS_BUNDLEIDS_IDS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
    },
    mounted() {
        this.$store.dispatch('CreateAudienceStore/fetchSignalProviders', this.dataSetOrder)
        this.$store.dispatch('CreateAudienceStore/fetchAppsCategories', this.dataSetOrder)
        this.$store.dispatch('CreateAudienceStore/fetchAppsTags', this.dataSetOrder)
        this.$store.dispatch('CreateAudienceStore/fetchAppsOs', this.dataSetOrder)
        this.$store.dispatch('CreateAudienceStore/fetchCountries', this.dataSetOrder)

    },
    watch: {
        analysisType: function () {
            if ([this.analyses.types.poi, this.analyses.types.competitors, this.analyses.types.anonymized].includes(this.analysisType)) {
                this.$store.dispatch('CreateAudienceStore/fetchSignalProviders', this.dataSetOrder)
            }
            if ([this.analyses.types.anonymized].includes(this.analysisType)) {
                this.$store.dispatch('CreateAudienceStore/fetchCountries', this.dataSetOrder)
            }
            if ([this.analyses.types.cohorts].includes(this.analysisType)) {
                this.$store.dispatch('CreateAudienceStore/fetchCohorts', this.dataSetOrder)
            }
        }
    }
}
</script>

<style scoped>

</style>